/*
 *
 * Collaborators reducer
 *
 */

import { fromJS } from "immutable"
import {
  HAS_DIVISIONS_WATCHER,
  HAS_DIVISIONS_SUCCESS,
  HAS_DIVISIONS_FAILED,
  HAS_COLLABORATORS_WATCHER,
  HAS_COLLABORATORS_SUCCESS,
  HAS_COLLABORATORS_FAILED,
  GET_TEMPLATE_COLLABORATORS_WATCHER,
  GET_TEMPLATE_COLLABORATORS_SUCCESS,
  GET_TEMPLATE_COLLABORATORS_FAILED,
  UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
  UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS,
  UPLOAD_TEMPLATE_COLLABORATORS_FAILED,
  GET_COLLABORATORS_WATCHER,
  GET_COLLABORATORS_SUCCESS,
  GET_COLLABORATORS_FAILED,
  SEARCH_COLLABORATORS_WATCHER,
  SEARCH_COLLABORATORS_SUCCESS,
  SEARCH_COLLABORATORS_FAILED,
  GET_TEAM_WATCHER,
  GET_TEAM_SUCCESS,
  GET_TEAM_FAILED,
  GET_POTENTIAL_LEADERS_WATCHER,
  GET_POTENTIAL_LEADERS_SUCCESS,
  GET_POTENTIAL_LEADERS_FAILED,
  ASSIGN_LEADER_WATCHER,
  ASSIGN_LEADER_SUCCESS,
  GET_TEAM_POTENTIAL_WATCHER,
  GET_TEAM_POTENTIAL_SUCCESS,
  GET_TEAM_POTENTIAL_FAILED,
  ADD_EMPLOYEES_TEAM_WATCHER,
  REMOVE_EMPLOYEES_TEAM_WATCHER,
  REMOVE_COLLABORATORS_WATCHER,
  GET_MEASURES_WATCHER,
  GET_MEASURES_SUCCESS,
  GET_MEASURES_FAILED,
  HAS_SEGMENTS_WATCHER,
  HAS_SEGMENTS_SUCCESS,
  HAS_SEGMENTS_FAILED,
  GET_VISMA_PEOPLE_STATUS_WATCHER,
  GET_VISMA_PEOPLE_STATUS_SUCCESS,
  GET_VISMA_PEOPLE_STATUS_FAILED,
} from "./constants"

export const initialState = fromJS({
  hasDivisions: undefined,
  hasCollaborators: undefined,
  isDownloading: false,
  isUploading: false,
  collaborators: [],
  isLoadingCollaboratorsTable: false,
  collaboratorTeam: [],
  isLoadingCollaboratorTeam: false,
  isLoadingPotentialLeaders: false,
  potentialLeaders: [],
  teamPotential: [],
  isLoadingTeamPotential: false,
  isLoadingMeasures: false,
  measuresAffected: [],
  hasSegments: undefined,
  vismaPeopleStatus: {},
  isLoadingVismaPeopleStatus: false
})

function collaboratorsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TEAM_POTENTIAL_WATCHER:
      return (
        state
          // .set('teamPotential', [])
          .set("isLoadingTeamPotential", true)
      )
    case GET_TEAM_POTENTIAL_SUCCESS:
      return state
        .set("teamPotential", action.payload)
        .set("isLoadingTeamPotential", false)
    case GET_TEAM_POTENTIAL_FAILED:
      return state.set("teamPotential", []).set("isLoadingTeamPotential", false)
    case GET_VISMA_PEOPLE_STATUS_WATCHER:
      return state.set("isLoadingVismaPeopleStatus", true)
    case GET_VISMA_PEOPLE_STATUS_SUCCESS:
      return state.set('vismaPeopleStatus', action.payload).set("isLoadingVismaPeopleStatus", false)
    case GET_VISMA_PEOPLE_STATUS_FAILED:
      return state.set('vismaPeopleStatus', {}).set("isLoadingVismaPeopleStatus", false)
    case REMOVE_COLLABORATORS_WATCHER:
      return state.set("isLoadingCollaboratorsTable", true)

    case ASSIGN_LEADER_WATCHER:
      return state.set("isLoadingCollaboratorsTable", true)
    case ASSIGN_LEADER_SUCCESS:
      return state.set("potentialLeaders", [])

    case ADD_EMPLOYEES_TEAM_WATCHER:
      return state
        .set("isLoadingTeamPotential", true)
        .set("isLoadingCollaboratorTeam", true)

    case REMOVE_EMPLOYEES_TEAM_WATCHER:
      return state.set("isLoadingCollaboratorTeam", true)

    case GET_POTENTIAL_LEADERS_WATCHER:
      return state
        .set("potentialLeaders", [])
        .set("isLoadingPotentialLeaders", true)
    case GET_POTENTIAL_LEADERS_SUCCESS:
      return state
        .set("potentialLeaders", action.payload)
        .set("isLoadingPotentialLeaders", false)
    case GET_POTENTIAL_LEADERS_FAILED:
      return state
        .set("potentialLeaders", [])
        .set("isLoadingPotentialLeaders", false)

    case GET_TEAM_WATCHER:
      return state
        .set("collaboratorTeam", [])
        .set("isLoadingCollaboratorTeam", true)
    case GET_TEAM_SUCCESS:
      return state
        .set("collaboratorTeam", action.payload)
        .set("isLoadingCollaboratorTeam", false)
    case GET_TEAM_FAILED:
      return state
        .set("collaboratorTeam", [])
        .set("isLoadingCollaboratorTeam", false)

    case HAS_COLLABORATORS_WATCHER:
      return state.set("hasCollaborators", undefined)
    case HAS_COLLABORATORS_SUCCESS:
      return state.set("hasCollaborators", action.payload)
    case HAS_COLLABORATORS_FAILED:
      return state.set("hasCollaborators", undefined)
    case HAS_SEGMENTS_WATCHER:
      return state.set("hasSegments", undefined)
    case HAS_SEGMENTS_SUCCESS:
      return state.set("hasSegments", action.payload)
    case HAS_SEGMENTS_FAILED:
      return state.set("hasSegments", undefined)

    case HAS_DIVISIONS_WATCHER:
      return state.set("hasDivisions", undefined)
    case HAS_DIVISIONS_SUCCESS:
      return state.set("hasDivisions", action.payload)
    case HAS_DIVISIONS_FAILED:
      return state.set("hasDivisions", undefined)

    case GET_COLLABORATORS_WATCHER:
      return state
        .set("isLoadingCollaboratorsTable", true)
    case GET_COLLABORATORS_SUCCESS:
      return state
        .set("collaborators", action.payload)
        .set("isLoadingCollaboratorsTable", false)
    case GET_COLLABORATORS_FAILED:
      return state.set("isLoadingCollaboratorsTable", false)

    case GET_TEMPLATE_COLLABORATORS_WATCHER:
      return state.set("isDownloading", true)
    case GET_TEMPLATE_COLLABORATORS_SUCCESS:
      return state.set("isDownloading", false)
    case GET_TEMPLATE_COLLABORATORS_FAILED:
      return state.set("isDownloading", false)

    case UPLOAD_TEMPLATE_COLLABORATORS_WATCHER:
      return state.set("isUploading", true)
    case UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS:
      return state.set("isUploading", false)
    case UPLOAD_TEMPLATE_COLLABORATORS_FAILED:
      return state.set("isUploading", false)
    case SEARCH_COLLABORATORS_WATCHER:
      return state.set("isLoadingCollaboratorsTable", true)
    case SEARCH_COLLABORATORS_SUCCESS:
      return state
        .set("isLoadingCollaboratorsTable", false)
        .set("collaborators", action.payload)
    case SEARCH_COLLABORATORS_FAILED:
      return state
        .set("isLoadingCollaboratorsTable", false)
        .set("collaborators", [])
    case GET_MEASURES_WATCHER:
      return state.set("measuresAffected", []).set("isLoadingMeasures", true)
    case GET_MEASURES_SUCCESS:
      return state
        .set("measuresAffected", action.payload.result.measures)
        .set("isLoadingMeasures", false)
    case GET_MEASURES_FAILED:
      return state
    default:
      return state
  }
}

export default collaboratorsReducer
